import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import {
  patchState,
  signalStore,
  withHooks,
  withMethods,
  withState,
} from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { filter, pipe, switchMap } from 'rxjs';
import { DiagnosisSessionService } from 'src/app/core/services/diagnosis-session.service';
import { StoreService } from 'src/app/core/services/global-store/store.service';
import { PairChallenge } from 'src/app/views/select-challenge/components/select-challenges-container/challenges-sub-challenges/challenges-sub-challenges.model';
import { ReviewSelectedChallangesState } from './review-selected-challanges.model';

const initialState: ReviewSelectedChallangesState = {
  selectedChallenges: [],
};

export type ReviewSelectedChallangesStoreType = InstanceType<
  typeof ReviewSelectedChallangesStore
>;

export const ReviewSelectedChallangesStore = signalStore(
  withState(initialState),
  withMethods(
    (
      store,
      diagnosisSessionService = inject(DiagnosisSessionService),
      storeService = inject(StoreService),
    ) => ({
      getPairChallengesFromStore: rxMethod<void>(
        pipe(
          switchMap(() => storeService.getPairChallenge()),
          tapResponse(
            (pairChallenges: PairChallenge[]) => {
              patchState(store, {
                selectedChallenges: pairChallenges,
              });
            },
            (error: HttpErrorResponse) => {
              console.error(
                'An error occurred in getPairChallengesFromStore:',
                error,
              );
            },
          ),
        ),
      ),
      getSelectedChallenges: rxMethod<string>(
        pipe(
          filter((diagnosisSessionId) => !!diagnosisSessionId),
          switchMap((diagnosisSessionId: string) =>
            diagnosisSessionService.getSessionChallenges(diagnosisSessionId),
          ),
          tapResponse(
            (sessionChallenges) => {
              const filterdPairChallenges = sessionChallenges.map(
                (challenge) => ({
                  challengeName: challenge.subChallenge.challengeName,
                  subChallengeId: challenge.subChallengeId,
                  subChallengeName: challenge.subChallenge.name,
                }),
              );
              patchState(store, {
                selectedChallenges: filterdPairChallenges,
              });
            },
            (error: HttpErrorResponse) => {
              console.error(
                'An error occurred in getSelectedChallenges:',
                error,
              );
            },
          ),
        ),
      ),
    }),
  ),
  withHooks({
    onInit({ getPairChallengesFromStore }) {
      getPairChallengesFromStore();
    },
  }),
);
